import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import api from "../../../../store/api";
import { AppThunk, RootState } from "../../../../store/app";
import Config from "../../../../config/Config";
import { apiUrls } from "./apiUrls";
interface InitialState {
  isLoading: boolean;
  agGrid: any;
  rowData: any;
  perPage: any;
  fileRowdata: any;
  careers: any;
  details: any;
}

const initialState = {
  isLoading: false,
  agGrid: null,
  rowData: null,
  careers: null,
  fileRowdata: null,
  perPage: Config.grid.server.gridOptions?.paginationPageSize,
  details: null,
} as InitialState;

const careerPathSlice = createSlice({
  name: "careerPath",
  initialState,
  reducers: {
    start: (state) => {
      state.isLoading = true;
    },
    success: (state) => {
      state.isLoading = false;
    },
    failure: (state) => {
      state.isLoading = false;
    },
    setRowData: (state, action: PayloadAction<any>) => {
      state.rowData = action?.payload;
    },
    setFileRowData: (state, action: PayloadAction<any>) => {
      state.fileRowdata = action?.payload;
    },
    setGrid: (state, action: PayloadAction<any>) => {
      state.agGrid = action?.payload;
    },
    setPerPage: (state, action: PayloadAction<any>) => {
      state.perPage = action?.payload;
      if (state.agGrid) {
        state.agGrid.api.paginationSetPageSize(Number(state.perPage));
        state.agGrid.api.setCacheBlockSize(state.perPage);
      }
    },
    setCareers: (state, action: PayloadAction<any>) => {
      state.careers = action?.payload;
    },
    setDetails: (state, action: PayloadAction<any>) => {
      state.details = action?.payload;
    },
  },
});

export const {
  start,
  success,
  setCareers,
  failure,
  setFileRowData,
  setGrid,
  setRowData,
  setPerPage,
  setDetails,
} = careerPathSlice.actions;

/** For Listing:Start */
export const fetchList =
  (action?: any): AppThunk<any> =>
  async (dispatch, getState: () => RootState) => {
    const initialAppOption: any = getState().auth.initialData;
    try {
      dispatch(start());
      dispatch(setRowData([]));
      const response = await api.get(apiUrls.list, action);
      const modifiedData = response.data.rows.map((row: any) => {
        return {
          ...row,
          career_level: initialAppOption?.career_path_levels?.find(
            (answer: any) => answer.id === row.career_level
          )?.name,
        };
      });

      dispatch(setRowData(modifiedData));
      dispatch(success());
      return Promise.resolve(response.data);
    } catch (error: any) {
      dispatch(failure());
      return Promise.reject(error.data);
    }
  };

/** For Listing:End */

export const createRecord =
  (action: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      dispatch(start());
      const response = await api.post(apiUrls.create, action);
      dispatch(success(response.data));
      dispatch(fetchList());
      return Promise.resolve(response.data);
    } catch (error: any) {
      dispatch(failure(error.data));
      return Promise.reject(error.data);
    }
  };

  //** For Import:Start */
export const uplodeFile =
  (action: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      dispatch(start());
      const response = await api.post(apiUrls.uplodefile, action);
      dispatch(success(response.data));
      dispatch(setFileRowData(response.data.import_data));
      return Promise.resolve(response.data);
    } catch (error: any) {
      dispatch(failure(error.data));
      return Promise.reject(error.data);
    }
  };

export const importFile =
  (action: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      dispatch(start());
      const response = await api.post(apiUrls.importfile, action);
      dispatch(success(response.data));
      dispatch(fetchList());
      return Promise.resolve(response.data);
    } catch (error: any) {
      dispatch(failure(error.data));
      return Promise.reject(error.data);
    }
  };
  //** For Import:End

export const getcareers = (): AppThunk<any> => async (dispatch) => {
  try {
    dispatch(start());
    const response = await api.get(apiUrls.career);
    dispatch(setCareers(response.data.data));
    dispatch(success());
    return Promise.resolve(response.data);
  } catch (error: any) {
    dispatch(failure(error.data));
    return Promise.reject(error.data);
  }
};
export const updateRecord =
  (id: number, action: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      dispatch(start());
      const response = await api.post(apiUrls.update(id), action);
      dispatch(success(response.data));
      dispatch(fetchList());
      return Promise.resolve(response.data);
    } catch (error: any) {
      dispatch(failure(error.data));
      return Promise.reject(error.data);
    }
  };

export const deleteRecord =
  (id: number, action: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      dispatch(start());
      const response = await api.delete(apiUrls.delete(id), action);
      dispatch(success(response.data));
      dispatch(fetchList());
      return Promise.resolve(response.data);
    } catch (error: any) {
      dispatch(failure(error.data));
      return Promise.reject(error.data);
    }
  };

export const changeStatus =
  (id: number, status: number): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(apiUrls.changeStatus(id), { status });
      dispatch(fetchList());
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

const careerPathReducer = careerPathSlice.reducer;
export default careerPathReducer;
